const getCartKey = userId => `CART_ITEMS_${userId}`;

export const saveCartToStorage = (items, userId) => {
  if (!userId) {return;}
  localStorage.setItem(getCartKey(userId), JSON.stringify(items));
};

export const getCartItemsByUserId = userId => {
  if (!userId) {return [];}
  try {
    const stored = localStorage.getItem(getCartKey(userId));
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error reading cart:', error);
    return [];
  }
};

export const clearCartStorage = userId => {
  if (!userId) {return;}
  localStorage.removeItem(getCartKey(userId));
};
